import { useEffect } from 'react'

export default function useUnmount(callback) {
  return useEffect(() => {
    return callback
  }, [])
}
